import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAnalyticsConsent, setAnalyticsConsent } from '../services/analyticsService';

const CookieBanner = ({ user }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Migration ancien bandeau "Compris"
    if (localStorage.getItem('cookies-accepted')) {
      localStorage.removeItem('cookies-accepted');
    }
    // Afficher si aucun choix fait
    if (!getAnalyticsConsent()) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent('granted');
    setVisible(false);
  };

  const handleRefuse = () => {
    setAnalyticsConsent('denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed ${user ? 'bottom-16 lg:bottom-0' : 'bottom-0'} left-0 right-0 z-50 bg-gray-900 text-white px-4 py-3 shadow-lg`}
    >
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-gray-300 text-center sm:text-left">
          {t('cookies.message')}{' '}
          <a href="/confidentialite" className="text-rose-400 hover:underline">
            {t('cookies.learnMore')}
          </a>
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleRefuse}
            className="bg-transparent border border-gray-500 hover:border-gray-300 text-gray-300 hover:text-white px-5 py-2 rounded-full text-sm font-semibold transition whitespace-nowrap"
          >
            {t('cookies.refuse')}
          </button>
          <button
            onClick={handleAccept}
            className="bg-rose-500 hover:bg-rose-600 text-white px-5 py-2 rounded-full text-sm font-semibold transition whitespace-nowrap"
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
